import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import useProductAttributes from 'data-hooks/useProductAttributes/index';
import PDPInfoDimensionsSection from './PDPInfoDimensionsSection';
import PDPInfoDescriptionSection from './PDPInfoDescriptionSection';
import PDPInfoDetailsSection from './PDPInfoDetailsSection';
import PDPInfoCareSection from './PDPInfoCareSection';
export const PDP_INFO_DIMENSIONS_ID = 'pdp-info-dimensions';
export const PDP_INFO_DESCRIPTION_ID = 'pdp-info-description';
export const PDP_INFO_DETAILS_ID = 'pdp-info-details';
export const PDP_INFO_CARE_ID = 'pdp-info-care';

/**
 * The four product-info sections the layout revamp moves out of the rail, as
 * TabPanel items. A section whose data is missing drops out entirely, so a
 * product without care copy shows three tabs rather than an empty fourth.
 */
const usePDPInfoSections = () => {
  const $ = _c(13);
  const {
    data: t0
  } = useProductAttributes();
  const {
    dimensions,
    boxDimensions,
    description,
    additional_attributes: additionalAttributes,
    constructionDetails,
    productCareDetails,
    productPDF,
    assemblyDetailsPDF
  } = t0;
  const hasDescription = !!description || !!additionalAttributes?.showpiece_desc;
  const hasDimensions = !!dimensions?.length || !!boxDimensions?.length;
  const hasDetails = !!constructionDetails?.length || !!productPDF || !!assemblyDetailsPDF;
  productCareDetails?.length;
  let t1;
  if ($[0] !== hasDimensions) {
    t1 = hasDimensions && {
      id: PDP_INFO_DIMENSIONS_ID,
      label: "Product Dimensions",
      content: <PDPInfoDimensionsSection />
    };
    $[0] = hasDimensions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hasDescription) {
    t2 = hasDescription && {
      id: PDP_INFO_DESCRIPTION_ID,
      label: "Product Description",
      content: <PDPInfoDescriptionSection />
    };
    $[2] = hasDescription;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== hasDetails) {
    t3 = hasDetails && {
      id: PDP_INFO_DETAILS_ID,
      label: "Product Details",
      content: <PDPInfoDetailsSection />
    };
    $[4] = hasDetails;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== productCareDetails?.length) {
    t4 = productCareDetails?.length && {
      id: PDP_INFO_CARE_ID,
      label: "Product Care",
      content: <PDPInfoCareSection />
    };
    $[6] = productCareDetails?.length;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = [t1, t2, t3, t4].filter(Boolean);
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default usePDPInfoSections;